import clsx from 'clsx';
import type { CSSProperties, ReactElement, ReactNode } from 'react';
import * as styles from './style.css';
import type { RadioClip } from '../types';

type ClipBadgeProps = {
  clip: RadioClip;
  children?: ReactNode;
  count?: number;
  className?: string;
  size?: keyof typeof styles.clipBadge;
  style?: CSSProperties;
  testId?: string;
};

export function ClipBadge({
  clip,
  count,
  className,
  size = 'md',
  style,
  children = clip.code,
  testId,
}: ClipBadgeProps): ReactElement {
  const color = styles.clipColors[(clip.code.charCodeAt(0) - 65) % styles.clipColors.length];
  return (
    <span
      className={clsx(styles.clipBadge[size], className)}
      style={{ ...style, backgroundColor: color }}
      data-testid={testId}
    >
      {children}
      {count != null && count > 1 && <span className={styles.cellCount}>×{count}</span>}
    </span>
  );
}
